<template>
  <div data-name="RoleCardMenu" data-node-id="15235:186917">
    <HorizontalMenu
      :items="menuItems"
      size="small"
      :bottomLine="false"
      :fixedTabs="false"
      :value="selectedTab"
      @onChange="handleTabChange"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import HorizontalMenu from '@components/HorizontalMenu/HorizontalMenu.vue';

const props = defineProps({
  active_responsibilities_count: {
    type: Number,
    default: 0,
    validator: value => typeof value === 'number' && value >= 0
  },
  current_assignments_count: {
    type: Number,
    default: 0,
    validator: value => typeof value === 'number' && value >= 0
  },
  has_purpose: {
    type: Boolean,
    default: false
  },
  /** idea-MDP-523: when true, Context tab uses numeric count instead of "+" badge. */
  show_context_count_badge: {
    type: Boolean,
    default: false
  },
  context_files_count: {
    type: Number,
    default: 0,
    validator: value => typeof value === 'number' && value >= 0
  },
  has_context: {
    type: Boolean,
    default: false
  },
  value: {
    type: Number,
    default: 0
  },
  attached_to_positions_count: {
    type: Number,
    default: 0
  }
});
const emit = defineEmits(['tab-change']);

const selectedTab = computed(() => props.value);

const menuItems = computed(() => {
  const responsibilitiesCount = (props.active_responsibilities_count === '' || props.active_responsibilities_count === null || props.active_responsibilities_count === undefined) 
    ? 0 
    : Math.abs(Number(props.active_responsibilities_count));
  
  const assignmentsCount = (props.current_assignments_count === '' || props.current_assignments_count === null || props.current_assignments_count === undefined) 
    ? 0 
    : Math.abs(Number(props.current_assignments_count));

  const attachedToPositionsCount = (props.attached_to_positions_count === '' || props.attached_to_positions_count === null || props.attached_to_positions_count === undefined) 
    ? 0 
    : Math.abs(Number(props.attached_to_positions_count));

  const filesCount = (props.context_files_count === '' || props.context_files_count === null || props.context_files_count === undefined)
    ? 0
    : Math.abs(Number(props.context_files_count));

  const contextItem = props.show_context_count_badge
    ? { title: 'Context', count: filesCount + (props.has_context ? 1 : 0) }
    : { title: 'Context', count: null, showPlusBadge: props.has_purpose };

  return [
    { title: 'Attached Responsibilities', count: responsibilitiesCount },
    { title: 'Attached to Positions', count: attachedToPositionsCount },
    { title: 'Assignments', count: assignmentsCount },
    contextItem
  ];
});

function handleTabChange(value) {
  emit('tab-change', value);
}
</script>
